import { render, staticRenderFns } from "./tag-input.vue?vue&type=template&id=0bca9855&"
import script from "./tag-input.vue?vue&type=script&lang=js&"
export * from "./tag-input.vue?vue&type=script&lang=js&"
import style0 from "./tag-input.vue?vue&type=style&index=0&id=0bca9855&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports